<script>
  export let json
  export let location
</script>

<button on:click|self class="fixed inset-0 -top-3 z-50 flex items-center justify-center bg-[#000000cc] p-6 backdrop-blur-md">
  <div>
    <div class="min-w-[330px] cursor-default rounded-t-md bg-white px-6 pt-6 dark:bg-bodyblack mobile:w-[400px]">
      <div class="flex w-full flex-col items-start space-y-3 py-3">
        <h1 class="text-lg font-bold dark:text-white mobile:text-2xl">IP Access Details</h1>
        <div class="flex w-full justify-start">
          <span class="w-full text-start text-xs font-bold text-gray-400 mobile:text-base">IP Address</span>
          <span class="text-mono w-full text-start text-xs text-gray-600 dark:text-gray-200 mobile:text-base">{json.ip}</span>
        </div>
        <div class="flex w-full justify-start">
          <span class="w-full text-start text-xs font-bold text-gray-400 mobile:text-base">City</span>
          <span class="w-full text-start text-xs text-gray-600 dark:text-gray-200 mobile:text-base">{location.city || "No Data"}</span>
        </div>
        <div class="flex w-full justify-start">
          <span class="w-full text-start text-xs font-bold text-gray-400 mobile:text-base">Region</span>
          <span class="w-full text-start text-xs text-gray-600 dark:text-gray-200 mobile:text-base">{location.region || "No Data"}</span>
        </div>
        <div class="flex w-full justify-start">
          <span class="w-full text-start text-xs font-bold text-gray-400 mobile:text-base">Country</span>
          <span class="flex w-full items-center gap-3 text-start text-xs text-gray-600 dark:text-gray-200 mobile:text-base">
            {#if location.countryCode}
              <span class="flag flag-{location.countryCode.toLowerCase()}  overflow-hidden" />
            {/if}
            <span>{location.country || "No Data"}</span>
          </span>
        </div>
        <div class="flex w-full justify-between">
          <span class="w-1/2 text-start text-xs font-bold text-gray-400 mobile:text-base" />
          <span class="flex w-1/2 items-center gap-3 text-start text-xs text-gray-600 dark:text-gray-200 mobile:text-base">
            <span class="flex items-center gap-3 font-thin text-gray-100/50 dark:text-gray-800 mobile:text-base">
              <i class="fa-solid fa-circle-info" />
              <span>source:&nbsp;ipstack.com</span>
            </span>
          </span>
        </div>
      </div>
    </div>
    <div class="rounded-b-md border-t border-[#a0a1a580] bg-white py-3 dark:bg-bodyblack">
      <button on:click class="mx-auto flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md bg-red-500 px-2 text-sm font-bold text-white hover:bg-red-600 hover:text-white focus:outline-none active:bg-red-400 active:text-white disabled:cursor-not-allowed dark:text-white dark:hover:hover:bg-red-600 mobile:min-w-[120px]">
        <i class="fa-solid fa-circle-xmark" />
        &nbsp;&nbsp;Close
      </button>
    </div>
  </div>
</button>
